module.exports = __webpack_public_path__ + "static/media/logo3.18b66279.svg";